import React from "react";
import Header from "./layout/header";

import Home from "./Home";
import Footer from "./layout/footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Home />
      <Footer />
    </div>
  );
}

export default App;
